import React, { useEffect, useState } from "react";
import { Image, Layer, Stage } from "react-konva";
import "../../Assets/Styles/pages/canvas.scss";
import LogoImage from "../LogoImage/logoImage";
import { useDispatch, useSelector } from "react-redux";
import {
  setCreate,
  setImage,
  setTemplateClearPhase1,
} from "../../Redux/DownloadSlice/downloadSlice";
import {
  setActiveStickersSrc,
  setRecentlyUsed,
} from "../../Redux/Stickers/stickersSlice";
import {
  changeItemProperties,
  deleteAll,
  setActiveId,
  setItem,
  setLoaded,
  setScreenShot,
  setTemplateLoaded,
  setWaterMarksLoader,
} from "../../Redux/WaterMarks/wateramarks";
import { useRef } from "react";
import { Row } from "react-bootstrap";
import helper_functions from "../../Config/helper_functions";
import { canvasPreview } from "../Cropper/canvasPreview";
import DownloadLogoImage from "../LogoImage/donwloadLogoImage";
import DownloadText from "../Text/downloadText";
import TextComponent from "../Text/text";
import {
  removeBatchUrlImage,
  setCurrentIndex,
  setImageCanvasExceeded,
  setLoader,
  setOrientation,
} from "../../Redux/MainImage/imageSlice";
import { setCanvasSize } from "../../Redux/UserSlice/userSlice";
import { GetTemplateDataFromRedux } from "../../actions/Template/Template";
import { CircularProgress } from "@mui/material";

// this function creates the link, attaches the download file to it and then download it
// function downloadImage(uri, name) {
//   var link = document.createElement("a");
//   link.download = name;
//   link.href = uri;
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// }

function Canvas({
  setActive,
  setUrls,
  Urls,
  mainImage,
  setMainImage,
  waterMarks,
  setWaterMarks,
  batchStarted,
}) {
  // const [waterMarksImages, setWaterMarksImages] = useState([]);

  const [originalImageHeight, setOriginalImageHeight] = useState(0);
  const [originalImageWidth, setOriginalImageWidth] = useState(0);
  const [differenceFactor, setDifferenceFactor] = useState(1);
  const [activId, setActive1d] = useState();
  const [canvasWidth, setCanvasWidth] = useState();
  const [canvasHeight, setCanvasHeight] = useState();
  const [canvasImageWidth, setCanvasImageWidth] = useState(0);
  const [canvasImageHeight, setCanvasImageHeight] = useState(0);
  const [xCordsOfMainImage, setXCordsOfMainImage] = useState(0);
  const [yCordsOfMainImage, setYCordsOfMainImage] = useState(0);
  const [xPointsToAdd, setXPointsToAdd] = useState(0);
  const [yPointsToAdd, setYPointsToAdd] = useState(0);
  const [ImageReload, setImageReload] = useState(false);
  const [create, setcreate] = useState(null);
  const [completedCrop, setCompletedCrop] = useState({});
  const [imgSrc, setImgSrc] = useState("");
  const [template, setTemplate] = useState(false);
  const [square, setSquare] = useState(false);
  const [downloadStarted, setdownloadStarted] = useState(false);
  const [change, setchange] = useState(false);

  const stageRef = useRef();
  const layerRef = useRef();
  const stageSecondaryRef = useRef();
  const shapeRef = useRef();
  const previewCanvasRef = useRef(null);
  const imgRef = useRef(null);

  const file = useSelector((state) => state.mainImage);
  const stickerState = useSelector((state) => state["stickers"]);
  const waterMarksState = useSelector((state) => state["watermarks"]);
  const downloadState = useSelector((state) => state["downloadSlice"]);
  const userSliceState = useSelector((state) => state["userSlice"]);
  const templateSlice = useSelector((state) => state["templateSlice"]);
  const mainImageState = useSelector((state) => state["mainImage"]);

  const dispatch = useDispatch();

  const setImageCanvasExceededDispatch = (stateSetter) => {
    if (file.ImageCanvasExceeded !== stateSetter)
      dispatch(setImageCanvasExceeded(stateSetter));
  };

  useEffect(() => {
    setcreate(downloadState.Create);
  }, [downloadState.Create]);
  useEffect(() => {
    setTemplate(waterMarksState.template);
  }, [waterMarksState.template]);

  useEffect(() => {
    setActive1d(waterMarksState.activeId);
  }, [waterMarksState.activeId]);
  useEffect(() => {
    if (canvasImageWidth === 0 || isNaN(canvasImageWidth)) {
      setImageReload(!ImageReload);
    }
  }, []);

  // **********to Template***************\\

  useEffect(() => {
    setchange(true);
  }, [userSliceState.template_Edit, userSliceState.templateChanged]);

  const downloadBatchImage = async (
    img,
    originalImageHeight,
    originalImageWidth
  ) => {
    var width, height;

    if (downloadState.Resolution) {
      width = downloadState.Resolution;
      // Calculate height to maintain aspect ratio
      height =
        (downloadState.Resolution / originalImageWidth) * originalImageHeight;
    } else {
      width = originalImageWidth;
      height = originalImageHeight;
    }

    var image = await helper_functions.resizeFile(
      img,
      width,
      height,
      downloadState.Format ? downloadState.Format : file.extension,
      downloadState.Quality
    );
    var name =
        "image." +
        (downloadState.Format ? downloadState.Format : file.extension),
      uri = image;
    setUrls((prevArray) => [...prevArray, name]);

    var link = document.createElement("a");
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // **********to Download***************\\

  //on creating the second canvas we set its refference i.e. stageSecondaryRef, then we call toDataURL to get the base 64 image string
  //in the quality and imgae type as defined.
  useEffect(() => {
    const fetchData = async () => {
      if (create === 1 && waterMarksState.items.length === waterMarks.length) {
        dispatch(setActiveId(""));
        setActive("");
        setActive1d(null);
        if (
          stageSecondaryRef.current &&
          stageSecondaryRef.current.attrs.height !== 0
        ) {
          const dataURL = stageSecondaryRef.current.toDataURL({
            mimeType: "image/png",
            quality: 1,
          });

          if (userSliceState.batchDownload && batchStarted) {
            downloadBatchImage(
              dataURL,
              originalImageHeight,
              originalImageWidth
            );
            dispatch(setCreate(false));
            dispatch(setCurrentIndex(Urls.length + 1));
          } else {
            dispatch(
              setImage({
                img: dataURL,
                height: originalImageHeight,
                width: originalImageWidth,
                readyTodownload: true,
              })
            );
          }
          dispatch(setCreate(false));
        }
      } else if (create === -1) {
        if (
          stageRef.current &&
          stageRef.current.attrs.hasOwnProperty("height") &&
          stageRef.current.attrs.height !== 0
        ) {
          const dataURL = stageRef.current.toDataURL({
            mimeType: "image/png",
            quality: 1,
          });

          setImgSrc(dataURL);
          const cropProps = {
            unit: "px",
            x: xCordsOfMainImage,
            y: yCordsOfMainImage,
            width: canvasImageWidth,
            height: canvasImageHeight,
          };
          setCompletedCrop(cropProps);
        }
      } else if (create === -2 && downloadState.templateReady) {
        if (
          stageRef.current &&
          stageRef.current.attrs.hasOwnProperty("height") &&
          stageRef.current.attrs.height !== 0
        ) {
          const dataURL = stageRef.current.toDataURL({
            mimeType: "image/png",
            quality: 1,
          });

          dispatch(setTemplateClearPhase1(false));
          dispatch(
            setImage({
              img: dataURL,
              height: canvasImageHeight,
              width: canvasImageWidth,
            })
          );
        }
      }
    };

    if (mainImageState.currentIndex !== Urls.length + 1) {
      fetchData();
    }
  }, [
    create,
    waterMarks,
    downloadState.templateReady,
    dispatch,
    setActive,
    setActive1d,
    stageSecondaryRef,
    stageRef,
    originalImageHeight,
    originalImageWidth,
    xCordsOfMainImage,
    yCordsOfMainImage,
    canvasImageWidth,
    canvasImageHeight,
    batchStarted,
  ]);

  helper_functions.useDebounceEffect(
    async () => {
      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {
        canvasPreview(
          imgRef.current,
          previewCanvasRef.current,
          completedCrop,
          downloadImage
        );
      }
    },
    100,
    [completedCrop, imgRef, previewCanvasRef]
  );

  async function updateWatermarks() {
    dispatch(setLoader(true));

    if (!waterMarksState) return;

    const reduxIds = waterMarksState.items?.map((item) => item.id);
    const localIds = waterMarks?.map((item) => item.id);

    if (reduxIds.length > localIds.length) {
      // New watermarks were added
      const newIds = reduxIds.filter((id) => !localIds.includes(id));

      const newWatermarks = await Promise.all(
        waterMarksState.items
          .filter((item) => newIds.includes(item.id))
          ?.map(async (item) => {
            const processedWatermark = await processWatermark(item);
            return processedWatermark;
          })
      );

      if (userSliceState.template_Edit && newWatermarks.length) {
        setWaterMarks([...new Set([...waterMarks, ...newWatermarks])]);
      } else {
        setWaterMarks([...new Set([...waterMarks, ...newWatermarks])]);
      }
    } else if (reduxIds.length < localIds.length) {
      // Some watermarks were removed
      const removedIds = localIds.filter((id) => !reduxIds.includes(id));

      setWaterMarks((prevWatermarks) =>
        prevWatermarks.filter((item) => !removedIds.includes(item.id))
      );
    } else if (reduxIds.length === localIds.length) {
      if (waterMarksState.activeId || !downloadStarted) {
        // Handle updates if needed
        const updatedWatermarks = waterMarksState.items?.map((item) => {
          const index = waterMarks.findIndex(
            (watermark) => watermark.id === item.id
          );

          if (index !== -1) {
            const cords = helper_functions.percent_To_pixel(
              item.x,
              item.y,
              window.innerHeight / 1.12,
              window.innerHeight / 1.12
            );
            const updatedWatermark = {
              ...waterMarks[index],
              ...item,
              x: cords.x,
              y: cords.y,
              // Additional properties to update if needed
            };
            return updatedWatermark;
          }
          return item;
        });

        setWaterMarks([...new Set(updatedWatermarks)]);
        dispatch(setLoader(false));
      } else if (
        downloadStarted &&
        userSliceState.batchDownload &&
        (xPointsToAdd || yPointsToAdd || square) &&
        originalImageHeight &&
        originalImageWidth
      ) {
        dispatch(setCreate(1));
        setdownloadStarted(false);
      }
    }

    dispatch(setLoader(false));
  }

  async function processWatermark(item) {
    let processedWatermark;

    const cords = helper_functions.percent_To_pixel(
      item.x,
      item.y,
      window.innerHeight / 1.12,
      window.innerHeight / 1.12
    );
    if (item.type === "image" || item.type === "signature") {
      let src;
      if (item.property !== "template")
        src = await helper_functions.convertToDataURL(item.src);
      else {
        src = item.src;
      }
      const createImageElement = new window.Image();
      createImageElement.crossOrigin = "anonymous";
      createImageElement.src = src;
      const imageProcessed = await imageProcessing(createImageElement);
      const scaleFactor = imageProcessed.scaleFactor;
      processedWatermark = await {
        ...item,
        x: cords.x,
        y: cords.y,
        image: createImageElement,
        alignEnable: item.alignEnable,
      };

      if (
        item.property !== "template" &&
        !item.hasOwnProperty("scaleFactor") &&
        !item.hasOwnProperty("ScaleApi")
      ) {
        scaleFactorMax(
          {
            ...item,
            scaleX: scaleFactor / 2,
            scaleY: scaleFactor / 2,
            scaleFactor: scaleFactor * 2,
          },
          "!== template"
        );
      } else if (
        item.property === "image" &&
        !item.hasOwnProperty("ScaleApi")
      ) {
        // else
        processedWatermark = {
          ...processedWatermark,
          scaleX: scaleFactor / 2,
          scaleY: scaleFactor / 2,
          scaleFactor: scaleFactor * 2,
        };
      }
    } else if (item.type === "text") {
      processedWatermark = {
        ...item,
        x: cords.x,
        y: cords.y,
      };
    }
    return processedWatermark;
  }

  useEffect(() => {
    //when we set the images in redux we cant set the image as JSX image element, instead we save the image url that is created in memory.
    //but we need the image as a JSX element to display on canvas, so in bellow code, on images data loaded from redux we take the
    //image url, create a new image element and assign the url to it and save it in the state.

    // setTimeout(async () => {

    const effectFunc = async () => {
      if (
        !template &&
        canvasWidth &&
        originalImageHeight &&
        originalImageWidth &&
        canvasImageWidth &&
        (yPointsToAdd || xPointsToAdd || square)
      ) {
        await updateWatermarks();
      } else if (
        template &&
        canvasWidth &&
        originalImageHeight &&
        originalImageWidth &&
        canvasImageWidth &&
        (yPointsToAdd || xPointsToAdd || square)
      ) {
        dispatch(setLoaded(false));
        dispatch(setTemplateLoaded(false));
        dispatch(setWaterMarksLoader(true));

        setTimeout(() => {
          dispatch(setWaterMarksLoader(false));
        }, 500);

        const item = await Promise.all(
          waterMarksState.items.filter(
            () => !waterMarksState.items.some((e) => e.property === "template")
          )
        );
        if (item.length) {
          const newImages = await Promise.all(
            item?.map(async (item) => {
              let cords = helper_functions.percent_To_pixel(
                item.x,
                item.y,
                window.innerHeight / 1.12,
                window.innerHeight / 1.12
              );
              if (item.type === "image" || item.type === "signature") {
                let src;
                if (item.property !== "template")
                  src = await helper_functions.convertToDataURL(item.src);
                else {
                  src = item.src;
                }
                const createImageElement = new window.Image();
                createImageElement.crossOrigin = "anonymous";
                createImageElement.src = src;
                const imageProcessed = await imageProcessing(
                  createImageElement
                );
                const scaleFactor = imageProcessed.scaleFactor;

                if (item.ScaleApi) {
                  let scale = helper_functions.decryptToScaleAndSize(
                    item.width,
                    canvasWidth,
                    imageProcessed.width
                  );
                  const x = cords.x + (imageProcessed.width * scale) / 2;
                  const y = cords.y + (imageProcessed.height * scale) / 2;
                  let newCords = helper_functions.pixel_To_percent(
                    x,
                    y,
                    window.innerHeight / 1.12,
                    window.innerHeight / 1.12
                  );
                  if (item.tag === 8)
                    console.log(
                      item,
                      "item",
                      { newCords, x: cords.x, width: imageProcessed.width },
                      "test Scales 1",
                      item.x,
                      {
                        x,
                        y,
                        scaledWidth: imageProcessed.width * scale,
                        center: (imageProcessed.width * scale) / 2,
                        scale,
                      }
                    );
                  scaleFactorMax(
                    {
                      ...item,
                      x: newCords.x,
                      y: newCords.y,
                      scaleX: scale,
                      scaleY: scale,
                      ScaleApi: false,
                      scaleFactor: scaleFactor * 2,
                    },
                    "ScaleApi"
                  );
                  return {
                    ...item,
                    ScaleApi: false,
                    scaleX: scale,
                    scaleY: scale,
                    scaleFactor: scaleFactor * 2,
                    x: x,
                    y: y,
                    image: createImageElement,
                  };
                } else
                  return {
                    ...item,
                    scaleX: scaleFactor / 2,
                    scaleY: scaleFactor / 2,
                    x: cords.x,
                    y: cords.y,
                    image: createImageElement,
                  };
              } else if (item.type === "text")
                return {
                  ...item,
                  x: cords.x,
                  y: cords.y,
                };
            })
          );

          setWaterMarks([...new Set(newImages)]);
          setTemplate(false);
        }
      }
    };

    effectFunc();
    // }, 50);
  }, [
    waterMarksState,
    canvasWidth,
    userSliceState.template_Edit,
    change,
    originalImageHeight,
    originalImageWidth,
    canvasImageWidth,
    file.url,
    file.currentIndex,
    xPointsToAdd,
    yPointsToAdd,
    originalImageHeight,
    originalImageWidth,
  ]);

  useEffect(() => {
    dispatch(setLoaded(true));
  }, [waterMarks]);
  // useEffect(() => {
  // }, [waterMarksImages])
  const scaleFactorMax = (properties) => {
    if (properties.tag === 8);
    dispatch(changeItemProperties(properties));
  };

  const imageProcessing = (createImageElement) => {
    return new Promise((resolve, reject) => {
      createImageElement.onload = () => {
        var width, height, scaleFactor;

        width = createImageElement.width;
        height = createImageElement.height;
        if (width > height) scaleFactor = canvasImageWidth / width;
        else scaleFactor = canvasImageHeight / height;

        // scale=scaleFactor/2;
        resolve({
          scaleFactor,
          width,
          height,
        });
      };
      createImageElement.onerror = reject;
    });
  };

  useEffect(() => {
    //here 2.2 is just a number by which we need to reduce the size of main canvas, canvas height and width are getting there values from
    // screen width only because we need a square canvas.

    const side = window.innerHeight / 1.12;

    setCanvasWidth(side);
    setCanvasHeight(side);
    dispatch(setCanvasSize(side));
  }, []);

  useEffect(() => {
    dispatch(setLoader(true));
    //  if (!(canvasImageWidth && canvasImageHeight && file.orientation) && canvasWidth) {
    if (mainImage) {
      setCanvasImageWidth(0);
      setCanvasImageHeight(0);
      dispatch(setOrientation(false));
      setMainImage(null);
      setXCordsOfMainImage(0);
      setYCordsOfMainImage(0);
    }
    // dispatch(setLoader(false))
  }, [file.url]);

  useEffect(() => {
    const effectFunc = async () => {
      dispatch(setLoader(true));
      // setTimeout(async () => {

      if (!userSliceState.edit_Template) {
        if (shapeRef.current && file.batchurls.length) {
          shapeRef.current.clearCache();
          setMainImage(null);

          setWaterMarks([]);
          setXPointsToAdd(0);
          setYPointsToAdd(0);
          setOriginalImageHeight(0);
          setOriginalImageWidth(0);
        }

        if (file.url && canvasWidth) {
          const image = new window.Image();
          image.src = file.url;
          image.onload = async () => {
            // if (shapeRef.current)
            //   shapeRef.current.clearCache()

            //this is the main background image which will be edited

            const imageHeight = image.height;
            const imageWidth = image.width;
            let difference;

            setOriginalImageHeight(imageHeight);
            setOriginalImageWidth(imageWidth);
            var orientation;
            // difference factor is the difference between the scale of original image and canvas
            //if the image is in landscape then difference factor is with respect to its width
            //if image is in portrate then it is according to image's height
            let canvasimageW = canvasImageWidth,
              canvasimageH = canvasImageHeight;
            if (
              !(canvasImageWidth && canvasImageHeight && file.orientation) &&
              canvasWidth
            ) {
              if (imageHeight > imageWidth) {
                // dispatch(setOrientation("portrait"))
                orientation = "portrait";
                setDifferenceFactor(imageHeight / canvasWidth);
                difference = imageHeight / canvasWidth;
              } else {
                orientation = "landscape";
                setDifferenceFactor(imageWidth / canvasWidth);
                difference = imageWidth / canvasWidth;
              }
              //below is the calculations for the image that will be displayed on the canvas
              canvasimageW = imageWidth / difference;
              canvasimageH = imageHeight / difference;
              dispatch(setOrientation(orientation));

              setCanvasImageWidth(canvasimageW);
              setCanvasImageHeight(canvasimageH);
            }
            if (!(file.orientation === false)) {
              await setMainImageCordinates(
                canvasimageH,
                canvasimageW,
                imageHeight,
                imageWidth
              ).then(async () => {
                setWaterMarks([]);
                if (file.batchurls.length && !userSliceState.batchDownload) {
                  setTemplate(false);
                  dispatch(deleteAll());
                  var url = file.batchurls[file.currentIndex];
                  if (url && url.hasOwnProperty("template")) {
                    var id = url.template;
                    dispatch(
                      GetTemplateDataFromRedux(
                        id,
                        templateSlice,
                        waterMarksState,
                        false
                      )
                    );
                  } else {
                    var tempID = userSliceState.current_TemplateID;
                    if (file.orientation === "landscape") {
                      if (tempID.landcsapeTemp) tempID = tempID.landcsapeTemp;
                      else {
                        if (tempID.portraitTemp) tempID = tempID.portraitTemp;
                      }
                    } else if (file.orientation === "portrait") {
                      if (tempID.portraitTemp) tempID = tempID.portraitTemp;
                      else {
                        if (tempID.landcsapeTemp) tempID = tempID.landcsapeTemp;
                      }
                    }
                    // tempID = orientation === "landscape" ? (tempID.landcsapeTemp ? tempID.landcsapeTemp :  ) : tempID.portraitTemp ? tempID.portraitTemp : tempID.landcsapeTemp
                    var template = userSliceState.template;

                    template = template.filter((item) => item.id === tempID)[0];
                    dispatch(
                      setScreenShot({
                        type: "image",
                        property: "template",
                        id: Date.now(),
                        x: 50,
                        y: 50,
                        deg: 0,
                        scaleX: 1,
                        scaleY: 1,
                        src: template.media.originalUrl,
                        opacity: 1,
                      })
                    );
                  }
                } else if (
                  file.batchurls.length &&
                  userSliceState.batchDownload
                ) {
                  url = await file.batchurls[file.currentIndex];
                  if (url.hasOwnProperty("template")) {
                    id = url.template;
                  } else {
                    id =
                      file.orientation === "landscape" && url.landcsapeTemp
                        ? url.landcsapeTemp
                        : url.portraitTemp
                        ? url.portraitTemp
                        : url.landcsapeTemp;
                  }
                  const create = dispatch(
                    GetTemplateDataFromRedux(
                      id,
                      templateSlice,
                      waterMarksState,
                      false,
                      true
                    )
                  );
                  if (create) {
                    setdownloadStarted(true);
                    setTemplate(true);
                  }
                }
                setMainImage(image);
              });
            }
          };
          image.onerror = () => {
            if (!file.batchurls.length) {
              dispatch(
                removeBatchUrlImage({
                  index: file.currentIndex,
                  setPrevious: true,
                })
              );
              alert("Selected file format is not supported.");
            }
          };
        }
      } else {
        setCanvasImageWidth(canvasWidth);
        setCanvasImageHeight(canvasWidth);
        setOriginalImageHeight(canvasWidth);
        setOriginalImageWidth(canvasWidth);
        setYCordsOfMainImage(0);
        setYPointsToAdd(0);
        setXPointsToAdd(0);
        setXCordsOfMainImage(0);
        setSquare(true);
      }
      // }, 50);

      dispatch(setLoader(false));
    };

    effectFunc();
  }, [file.url, canvasWidth, file.orientation]);

  useEffect(() => {
    let newimg = new window.Image();
    newimg.src = mainImageState?.batchurls[0]?.url;
  }, [batchStarted]);

  //this function is setting the X,Y cords of image to start.
  //because the canvas is square but the image might not be, if it is then X,Y cords will be default that is zero.
  //now if image is in land scape or portrate then we have to set cords accordingly, image will be in the center and there will be
  //white space on eighter x axis or y axis depending on the orientation of the image.
  const setMainImageCordinates = (
    canvasImageH,
    canvasImageW,
    originalImageHeight,
    originalImageWidth
  ) => {
    return new Promise((resolve, reject) => {
      if (canvasImageH !== 0 && canvasImageW !== 0) {
        if (originalImageWidth > originalImageHeight) {
          setYCordsOfMainImage((canvasWidth - canvasImageH) / 2);
          setYPointsToAdd((canvasWidth - canvasImageH) / 2);
          setXPointsToAdd(0);
          setXCordsOfMainImage(0);
          setSquare(false);
        } else if (originalImageWidth < originalImageHeight) {
          setXCordsOfMainImage((canvasWidth - canvasImageW) / 2);
          setXPointsToAdd((canvasWidth - canvasImageW) / 2);
          setYPointsToAdd(0);
          setYCordsOfMainImage(0);
          setSquare(false);
        } else {
          setXCordsOfMainImage(0);
          setXPointsToAdd(0);
          setYCordsOfMainImage(0);
          setYPointsToAdd(0);
          setSquare(true);
        }
        resolve("Main image coordinates set successfully.");
      } else {
        reject("Canvas image height or width is not loaded.");
      }
    });
  };

  //to deselect what has been selected
  const checkDeselect = (e) => {
    // deselect when clicked on empty area
    const clickedOnEmpty = e.target === e.target.getStage();
    if (waterMarksState.activeId)
      if (clickedOnEmpty) {
        dispatch(setActiveId(""));
        setActive("");
        setActive1d(null);
      }
  };

  const setWaterMarkProperties = (properties) => {
    let cords = helper_functions.pixel_To_percent(
      properties.x,
      properties.y,
      canvasWidth,
      canvasHeight
    );
    dispatch(
      changeItemProperties({
        ...properties,
        x: cords.x,
        y: cords.y,
        id: properties.id,
        alignEnable: properties.alignEnable,
        scaleX: properties.scaleX,
        scaleY: properties.scaleY,
        scaleXTransform: properties.scaleXTransform,
        scaleYTransform: properties.scaleYTransform,
      })
    );
  };
  const downloadImage = (uri) => {
    dispatch(
      setImage({
        img: uri,
        height: canvasImageHeight,
        width: canvasImageWidth,
      })
    );
    dispatch(setCreate(false));
  };
  return (
    <>
      <div
        style={{
          width: canvasWidth,
          height: canvasHeight,
        }}
        className={`${
          batchStarted
            ? "d-flex align-items-center justify-content-center"
            : "d-none"
        } placeholderdiv`}
      >
        <img
          src={mainImageState?.batchurls[0]?.url}
          alt="canvas perv"
          style={{
            maxHeight: "100%",
            maxWidth: "100%",
          }}
        />
      </div>
      <div
        className={`canvas ${
          batchStarted ? "d-none" : "d-flex"
        } justify-content-center`}
        style={{ width: canvasWidth, height: canvasHeight }}
        onDrop={(e) => {
          e.preventDefault();
          // register event position
          stageRef.current.setPointersPositions(e);
          // add image
          let ID = Date.now();
          if (stickerState.activeSrc !== "") {
            let cords = helper_functions.pixel_To_percent(
              stageRef.current.getPointerPosition().x,
              stageRef.current.getPointerPosition().y,
              window.innerHeight / 1.12,
              window.innerHeight / 1.12
            );
            dispatch(
              setItem({
                type: "image",
                property: "sticker",
                id: ID,
                x: cords.x,
                y: cords.y,
                deg: 0,
                scaleX: 0.25,
                scaleY: 0.25,
                src: stickerState.activeSrc,
                opacity: 1,
                name: stickerState.activeSrc.name,
                size: stickerState.activeSrc.size,
              })
            );
            dispatch(setRecentlyUsed(stickerState.sticker));
          }
          if (stickerState.activeSrc) {
            setActive("image");
            dispatch(setActiveStickersSrc(""));
          }
        }}
        onDragOver={(e) => e.preventDefault()}
      >
        {!waterMarksState.waterMarksloader &&
        !batchStarted &&
        userSliceState.online &&
        (mainImage ||
          (userSliceState.edit_Template &&
            (waterMarks.length || waterMarksState.deletedWaterMarkIds))) ? (
          <Stage
            style={{
              width: `${canvasWidth}px`,
              height: `${canvasHeight}px`,
              margin: "0 auto",
            }}
            className="canvas d-flex align-items-center justify-content-center"
            ref={stageRef}
            width={canvasWidth}
            height={canvasHeight}
            onMouseDown={checkDeselect}
            onTouchStart={checkDeselect}
          >
            <Layer ref={layerRef}>
              {!downloadState.templateReady_image &&
                !userSliceState.edit_Template && (
                  <Image
                    onClick={() => {
                      if (waterMarksState.activeId) {
                        setActive("");
                        setActive1d(null);
                        dispatch(setActiveId(""));
                      }
                    }}
                    ref={shapeRef}
                    x={xCordsOfMainImage}
                    y={yCordsOfMainImage}
                    image={mainImage}
                    width={canvasImageWidth}
                    height={canvasImageHeight}
                  />
                )}
              {}
              {waterMarks?.map((img) =>
                img.hasOwnProperty("type") && img.type === "image" ? (
                  <LogoImage
                    setActive={setActive}
                    key={img.id}
                    id={img.id}
                    active={activId}
                    setImageProperties={setWaterMarkProperties}
                    originalImageWidth={originalImageWidth / differenceFactor}
                    originalImageHeight={originalImageHeight / differenceFactor}
                    xCordsOfMainImage={xCordsOfMainImage}
                    yCordsOfMainImage={yCordsOfMainImage}
                    canvasImageHeight={canvasImageHeight}
                    canvasImageWidth={canvasImageWidth}
                    imageProperties={img}
                    differenceFactor={1}
                    xPointsToAdd={0}
                    yPointsToAdd={0}
                    draggable={
                      file.batchurls.length
                        ? userSliceState.template_Edit
                        : true
                    }
                    isSelected={
                      create === -1 || create === -2
                        ? null
                        : file.batchurls.length
                        ? userSliceState.template_Edit
                          ? img.id === activId
                          : false
                        : img.id === activId
                    }
                    onSelect={(id) => {
                      dispatch(setActiveId(id));
                    }}
                    onUnselect={() => {
                      dispatch(setActiveId(""));
                    }}
                    canvasWidth={canvasWidth}
                    canvasHeight={canvasHeight}
                    scaleFactorMax={scaleFactorMax}
                    setImageCanvasExceededDispatch={
                      setImageCanvasExceededDispatch
                    }
                  />
                ) : (
                  img.hasOwnProperty("type") &&
                  img.type === "text" && (
                    <TextComponent
                      userSliceState={userSliceState}
                      setActive={setActive}
                      key={img.id}
                      id={img.id}
                      active={waterMarksState.activeId}
                      textProperties={img}
                      setTextProperties={setWaterMarkProperties}
                      draggable={
                        file.batchurls.length
                          ? userSliceState.template_Edit
                          : true
                      }
                      isSelected={
                        create === -1 || create === -2
                          ? null
                          : img.id === activId
                      }
                      differenceFactor={1}
                      xCordsOfMainImage={xCordsOfMainImage}
                      yCordsOfMainImage={yCordsOfMainImage}
                      canvasImageHeight={canvasImageHeight}
                      canvasImageWidth={canvasImageWidth}
                      xPointsToAdd={0}
                      yPointsToAdd={0}
                      onSelect={(id) => {
                        dispatch(setActiveId(id));
                      }}
                      onUnselect={() => {
                        dispatch(setActiveId(""));
                      }}
                      canvasWidth={canvasWidth}
                      scaleFactorMax={scaleFactorMax}
                      shadowEnabled={img.enableShadowColor}
                      shadowOffsetX={-20}
                      shadowOffsetY={20}
                      shadowBlur={50}
                    />
                  )
                )
              )}
            </Layer>
          </Stage>
        ) : (
          <CircularProgress className="themeColor canvasLoader" />
        )}

        {/* {file.loader  &&
        <div className="canvasLoaderContainer">
          <CircularProgress className="themeColor m-3" />
        </div>
      } */}
        {create ? (
          <Stage
            ref={stageSecondaryRef}
            width={originalImageWidth}
            height={originalImageHeight}
            className="canvas"
            style={{ display: "none" }}
          >
            <Layer>
              <Image
                ref={shapeRef}
                x={0}
                y={0}
                image={mainImage}
                width={originalImageWidth}
                originalImageHeight={originalImageHeight}
              />
              {waterMarks?.map((img) =>
                img.hasOwnProperty("type") &&
                (img.type === "image" || img.type === "signature") ? (
                  <DownloadLogoImage
                    key={img.id}
                    imageProperties={img}
                    differenceFactor={differenceFactor}
                    xPointsToAdd={xPointsToAdd}
                    yPointsToAdd={yPointsToAdd}
                    originalImageWidth={originalImageWidth}
                    originalImageHeight={originalImageHeight}
                    setImageCanvasExceededDispatch={
                      setImageCanvasExceededDispatch
                    }
                  />
                ) : (
                  img.hasOwnProperty("type") &&
                  img.type === "text" && (
                    <DownloadText
                      key={img.id}
                      textProperties={img}
                      canvasWidth={canvasWidth}
                      differenceFactor={differenceFactor}
                      xPointsToAdd={xPointsToAdd}
                      yPointsToAdd={yPointsToAdd}
                      originalImageWidth={originalImageWidth}
                      originalImageHeight={originalImageHeight}
                      setImageCanvasExceededDispatch={
                        setImageCanvasExceededDispatch
                      }
                    />
                  )
                )
              )}
            </Layer>
          </Stage>
        ) : null}
        {
          <Row className="canvas_bg d-none justify-content-center">
            {!!completedCrop && (
              <canvas
                ref={previewCanvasRef}
                style={{
                  border: "1px solid black",
                  objectFit: "contain",
                  width: completedCrop.width,
                  height: completedCrop.height,
                }}
              />
            )}
            {<img className="d-none" ref={imgRef} alt="Crop me" src={imgSrc} />}
          </Row>
        }
      </div>
    </>
  );
}

export default Canvas;
